export const ACTION_TYPE = 'actionType';
export const TARGET_PROPERTY = 'targetProperty';
export const VALUE = 'value';